<template>
    <div
        v-if="isNonExtractionCriterion"
        class="CriterionSettingsDescription mb-6"
    >
        {{ descriptionText }}
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { CriterionTemplate } from '@evidentid/tprm-portal-lib/models/decisioning/Criterion.model';

    import {
        NON_EXTRACTION_FIELD_PREFIX, NON_EXTRACTION_SETTINGS_DESCRIPTION,
    } from '@/modules/decisioning-criteria/components/CriterionSettings/constants';

    export default defineComponent({
        name: 'CriterionSettingsDescription',
        props: {
            template: {
                type: Object as PropType<CriterionTemplate>,
                default: (): CriterionTemplate => ({}) as CriterionTemplate,
            },
        },
        computed: {
            isNonExtractionCriterion(): boolean {
                return this.template.field?.startsWith(NON_EXTRACTION_FIELD_PREFIX);
            },
            descriptionText(): string {
                if (this.isNonExtractionCriterion) {
                    return NON_EXTRACTION_SETTINGS_DESCRIPTION;
                }
                return '';
            },
        },
    });
</script>
